import { types } from 'mobx-state-tree';

export const DateTimeBlockModel = types
  .model('DateTimeBlockModel', {
    dateFrom: types.maybe(types.string),
    dateTo: types.maybe(types.string),
    startTime: types.maybeNull(types.string),
    endTime: types.maybeNull(types.string)
  })
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
